/* tslint:disable:max-line-length */
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push, replace } from 'redux-router';
import {
  ApiError,
  apiStatuses,
  ClearSpidToken,
  clearSpidToken,
  createOrder,
  fetchUserInfoDeferred,
  ICompanyPays,
  initializeSpid,
  InitializeSpid,
  InitializeSpidBound,
  productInfoDeferred,
  userLoggedInDeferred,
  validationErrors
} from '../actions/Actions';
import {
  IAddress,
  IProductInfo,
  IReduxRouterAction,
  IReferer,
  ISessionInfo,
  IState,
  IUserInfo,
  IUtm
} from '../CustomTypes';
import { decode, isValidUntilPassed } from '../fastflowUtils';
import { sccPulseTrackPageView } from '../PulseUtils';

export interface IUserInfoLandingPageParamProps {
  __rct?: string;
  companyContactEmail?: string;
  companyContactFirstName?: string;
  companyContactLastName?: string;
  companyContactPhone?: string;
  productInfo: IProductInfo;
  sessionInfo: ISessionInfo;
  userInfo: IUserInfo;
  address: IAddress;
  referer: IReferer;
  paymentMethodId?: string;
  paymentType: string;
  purchasedSubscriptionId: number;
  checkCodeApiStatus: string;
  b64data: string;
  utm: IUtm;
  organizationNumber?: string;
  companyName?: string;
  reference?: string;
  invoiceStreet?: string;
  invoiceCity?: string;
  invoiceZipCode?: string;
  loyaltyPartner?: string;
  loyaltyCode?: string;
}

export interface IUserInfoLandingPageActionProps {
  createOrder: createOrder;
  clearSpidToken: ClearSpidToken;
  initializeSpid: InitializeSpid;
  push: IReduxRouterAction;
  replace: IReduxRouterAction;
}
export interface IUserInfoLandingPageProps
  extends IUserInfoLandingPageParamProps,
    IUserInfoLandingPageActionProps {}
/**
 * This page is used to show a spinner until the order is placed
 */
export class UserInfoLandingPage extends React.Component<
  IUserInfoLandingPageProps,
  {}
> {
  constructor(props: IUserInfoLandingPageProps) {
    super(props);
    this.callCreateOrder = this.callCreateOrder.bind(this);
  }

  public componentWillMount() {
    if (
      this.props.checkCodeApiStatus &&
      this.props.checkCodeApiStatus === apiStatuses.SUCCESS
    ) {
      // Case for flow two when fetchUserInfoDeferred is failed
      this.callCreateOrder();
    } else {
      // Not Flow 2 || refresh
      fetchUserInfoDeferred.promise.then(() => {
        if (isValidUntilPassed(this.props.userInfo.validUntil)) {
          this.props.clearSpidToken(); // We only want to re-initialize spid once
          ((this.props.initializeSpid as any) as InitializeSpidBound)().then(
            () => {
              this.callCreateOrder();
            }
          );
        } else {
          this.callCreateOrder();
        }
      });
    }
  }

  public componentDidMount() {
    const eventName = 'Placing order';
    productInfoDeferred.promise.then(product => {
      userLoggedInDeferred.promise
        .then(userLoggedIn => {
          sccPulseTrackPageView(
            product,
            { spidId: Number(userLoggedIn.spidId) },
            eventName
          );
        })
        .catch(() => {
          sccPulseTrackPageView(product, {}, eventName);
        });
    });
  }

  public render() {
    return (
      <div className="container placeOrder component">
        <div className="col-xs-12">
          <br />
          <h1>Registrerer bestilling...</h1>
        </div>
      </div>
    );
  }

  private callCreateOrder() {
    let address = this.props.address;
    let phoneNumber = this.props.userInfo.phoneNumber;
    let referer = this.props.referer.referer;
    let redirectUri = this.props.referer.redirectUri;
    if (this.props.b64data) {
      const b64data = decode(this.props.b64data);
      if (b64data.address) {
        address = b64data.address;
      }
      if (b64data.phoneNumber) {
        phoneNumber = b64data.phoneNumber;
      }
      if (b64data.referer) {
        referer = b64data.referer.referer;
        redirectUri = b64data.referer.redirectUri;
      }
    }

    const {
      __rct,
      b64data,
      companyContactEmail,
      companyContactFirstName,
      companyContactLastName,
      companyContactPhone,
      createOrder,
      loyaltyPartner,
      loyaltyCode,
      paymentMethodId,
      paymentType,
      productInfo,
      push,
      replace,
      userInfo: { spidId, sig },
      purchasedSubscriptionId,
      companyName,
      organizationNumber,
      reference,
      invoiceCity,
      invoiceStreet,
      invoiceZipCode
    } = this.props;
    const { productId } = productInfo;
    const { campaign, content, medium, source, term } = this.props.utm;
    const companyPays = {
      companyName,
      invoiceCity,
      invoiceStreet,
      invoiceZipCode,
      organizationNumber,
      reference
    } as ICompanyPays;
    let rctParam = '';
    if (__rct) {
      rctParam = `&__rct=${__rct}`;
    }
    const receiptPageUrl = `/products/${productId}/receipt?spidId=${encodeURIComponent(
      '' + spidId
    )}&sig=${encodeURIComponent(sig)}&redirectUri=${encodeURIComponent(
      redirectUri
    )}&referer=${encodeURIComponent(
      referer
    )}&utm_source=${source}&utm_campaign=${campaign}&utm_content=${content}&utm_medium=${medium}&utm_term=${term}&paymentMethodId=${paymentMethodId}&paymentType=${paymentType}${rctParam}`;
    (createOrder({
      address,
      companyContactEmail,
      companyContactFirstName,
      companyContactLastName,
      companyContactPhone,
      companyPays,
      loyaltyCode,
      loyaltyPartner,
      paymentMethodId,
      paymentType,
      phoneNumber,
      productInfo,
      purchasedSubscriptionId,
      redirectUri,
      referer,
      sig,
      spidId
    }) as any)
      .then((data: any) => {
        replace(
          `${receiptPageUrl}&subscriptionId=${(data && data.subscriptionId) ||
            ''}`
        );
      })
      .catch((res: ApiError) => {
        if (res.status === 409) {
          this.props.replace(`${receiptPageUrl}&duplicate=true`);
        }
        if (
          res.status === 422 &&
          JSON.stringify(res).indexOf(validationErrors.PURCHASE_FAILED) !== -1
        ) {
          push(
            `/products/${productId}/selectpaymentmethod/${paymentMethodId}?error=${
              validationErrors.PURCHASE_FAILED
            }&spidId=${spidId}&sig=${sig}&b64data=${encodeURIComponent(
              b64data
            )}`
          );
        }
        if (res.errorCode === 1) {
          push(`/products/${productId}/productquarantined`);
        }
      });
  }
}

export default connect(
  (state: IState) =>
    ({
      __rct: state.router.location.query.__rct,
      address: state.address,
      b64data: state.router.location.query.b64data,
      checkCodeApiStatus: state.checkCode.apiStatus,
      companyContactEmail: state.router.location.query.companyContactEmail,
      companyContactFirstName:
        state.router.location.query.companyContactFirstName,
      companyContactLastName:
        state.router.location.query.companyContactLastName,
      companyContactPhone: state.router.location.query.companyContactPhone,
      companyName: state.router.location.query.companyName,
      invoiceCity: state.router.location.query.invoiceCity,
      invoiceStreet: state.router.location.query.invoiceStreet,
      invoiceZipCode: state.router.location.query.invoiceZipCode,
      loyaltyCode: state.userInfo.loyaltyCode,
      loyaltyPartner:
        state.productInfo.loyaltyPartner !== undefined
          ? state.productInfo.loyaltyPartner.name
          : undefined,
      organizationNumber: state.router.location.query.organizationNumber,
      paymentMethodId: state.router.location.query.paymentMethodId,
      paymentType: state.router.location.query.paymentType,
      productInfo: state.productInfo,
      purchasedSubscriptionId:
        state.router.location.query.purchasedSubscriptionId,
      reference: state.router.location.query.reference,
      referer: state.referer,
      sessionInfo: state.sessionInfo,
      userInfo: state.userInfo,
      utm: state.utm
    } as IUserInfoLandingPageParamProps),
  dispatch =>
    bindActionCreators(
      { createOrder, push, replace, initializeSpid, clearSpidToken },
      dispatch
    ) as IUserInfoLandingPageActionProps
)(UserInfoLandingPage);



// WEBPACK FOOTER //
// ./src/page-components/PlaceOrder.tsx